import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { timeout } from 'rxjs/operators';
import { environment } from 'src/environments/environment';

const TIMEOUT_MS = 300000; // 5 minutos

@Injectable({
  providedIn: 'root',
})
export class EmergencyService {
  private apiServerUrl = environment.loganConfig.url;

  constructor(private http: HttpClient) {}

  public getEmergencyCommands(): Observable<any[]> {
    return this.http
      .get<any[]>(`${this.apiServerUrl}/api/comandos/emergencia`, {
        withCredentials: true,
      })
      .pipe(timeout(TIMEOUT_MS));
  }

  public getEmergencyPositions(): Observable<any[]> {
    return this.http
      .get<any[]>(`${this.apiServerUrl}/api/positions/emergencia`, {
        withCredentials: true,
      })
      .pipe(timeout(TIMEOUT_MS));
  }

  public getDeviceInstallation(serial: string): Observable<any> {
    return this.http
      .get<any>(`${this.apiServerUrl}/api/devices/installation/${encodeURIComponent(serial)}`, {
        withCredentials: true,
      })
      .pipe(timeout(TIMEOUT_MS));
  }
}
